import { lazyWithPreload } from '@shared/utils/lazyWithPreload';

// Post-login landing page, code-split like every other page behind login (see
// routes/index.tsx). Kept out of the router so the login page can preload it
// without importing the router (which imports the login page).

// Preloaded while the user enters their OTP code, so the first screen after
// login opens without a loader
export const TemperoryFile = lazyWithPreload(
  () => import('@/epics/adminManagment/pages/temperoryFile')
);

/** Starts downloading the landing page ahead of navigation. */
export function preloadAfterLogin(): void {
  // A failed preload is harmless: the route loads again when navigated to
  TemperoryFile.preload().catch(() => {});
}
